/**
 * Represents the status of a selected ticket quantity.
 */
export var TicketQuantityStatus;
(function (TicketQuantityStatus) {
    /**
     * This ticket cannot be purchased.
     */
    TicketQuantityStatus["NotAllowed"] = "NotAllowed";
    /**
     * This ticket can be purchased.
     */
    TicketQuantityStatus["Allowed"] = "Allowed";
    /**
     * This ticket can be purchased, but too many have been selected for the current seat selections.
     */
    TicketQuantityStatus["Invalid"] = "Invalid";
})(TicketQuantityStatus || (TicketQuantityStatus = {}));
